import React, { Component } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsExportData from "highcharts/modules/export-data";
HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);

const CHART_CONFIGS = [
    {
        key: 'genre',
        title: 'Gênero',
        categories: ['Feminino', 'Masculino', 'Outros'],
        getIndex: (user) => {
            const genre = user.genre || "";
            if (genre === "Feminino") return 0;
            if (genre === "Masculino") return 1;
            return 2;
        }
    },
    {
        key: 'age',
        title: 'Idade',
        categories: ['Até 24', '25 a 34', '35 a 44', '45 a 54', 'Mais de 55'],
        getIndex: (user) => {
            const age = parseInt(user.age || 0);
            if (age <= 24) return 0;
            if (age <= 34) return 1;
            if (age <= 44) return 2;
            if (age <= 54) return 3;
            return 4;
        }
    },
    {
        key: 'marital_status',
        title: 'Estado Civil',
        categories: ['Solteiro(a)', 'Casado(a)', 'Divorciado(a)', 'Viúvo(a)'],
        getIndex: (user) => {
            const status = user.marital_status || "";
            if (status.includes("Solteiro")) return 0;
            if (status.includes("Casado")) return 1;
            if (status.includes("Separado") || status.includes("Divorciado")) return 2;
            if (status.includes("Viúvo")) return 3;
            return -1;
        }
    },
    {
        key: 'children',
        title: 'Filhos',
        categories: ['0', '1', '2', '3', '4+'],
        getIndex: (user) => {
            const qtd = parseInt(user.children || 0);
            if (qtd >= 4) return 4;
            return qtd;
        }
    },
    {
        key: 'income',
        title: 'Renda',
        // Maior para menor
        categories: ['+ R$12.500', 'R$10.001 a R$12.500', 'R$7.501 a R$10.000', 'R$5.001 a R$7.500', 'R$2.501 a R$5.000', 'Até R$2.500'],
        getIndex: (user) => {
            const val = parseFloat(user.income || 0);
            if (val > 12500) return 0;
            if (val > 10000) return 1;
            if (val > 7500) return 2;
            if (val > 5000) return 3;
            if (val > 2500) return 4;
            return 5;
        }
    }
];

class Graficos extends Component {

    calculateCounts = (users, config) => {
        const counts = Array(config.categories.length).fill(0);

        (users || []).forEach(user => {
            const index = config.getIndex(user);
            if (index >= 0 && index < counts.length) {
                counts[index]++;
            }
        });

        return counts;
    };

    calculatePercentages = (counts, total) => {
        if (!total) return counts.map(() => 0);

        return counts.map(count => Math.round((count / total) * 100));
    };

    getChartOptions = (title, categories, dataSeries) => {
        const color = '#4d5a31';
        const height = categories.length * 38 + 40;

        return {
            chart: {
                type: 'bar',
                height: height,
                marginLeft: 155,
                backgroundColor: 'transparent',
                style: { fontFamily: '"Archivo Expanded", Arial, sans-serif' }
            },
            title: { text: '' },
            xAxis: {
                categories: categories,
                lineWidth: 0,
                lineColor: 'transparent',
                labels: {
                    style: {
                        fontSize: '17.6px',
                        color: '#5b595b',
                        fontFamily: '"Archivo Expanded", Arial, sans-serif',
                        fontWeight: '400'
                    }
                }
            },
            yAxis: {
                min: 0, max: 100,
                title: { text: null },
                gridLineWidth: 0,
                labels: { enabled: false },
                plotLines: [{
                    value: 0,
                    width: 1.5,
                    color: '#5b595b',
                    zIndex: 5
                }]
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
                        format: '{y}%',
                        style: { fontWeight: 'bold', color: '#333', fontSize: '13px', textOutline: 'none' },
                        align: 'right',
                        x: 40
                    },
                    borderWidth: 0,
                    pointWidth: 22,
                    pointPadding: 0.02,
                    groupPadding: 0.05
                }
            },
            legend: { enabled: false },
            credits: { enabled: false },
            tooltip: { pointFormat: '<b>{point.y}%</b>' },
            series: [{
                name: title,
                data: dataSeries,
                color: color
            }]
        };
    };

    render() {
        const { users } = this.props.selectedArea || { users: [] };
        const total = users?.length || 0;

        return (
            <div style={{ padding: '20px', background: '#fff' }}>
                {CHART_CONFIGS.map((config) => {
                    const counts = this.calculateCounts(users, config);
                    const seriesData = this.calculatePercentages(counts, total);
                    const options = this.getChartOptions(config.title, config.categories, seriesData);

                    return (
                        <div key={config.key} className="geo-chart-item" data-area-id={this.props.areaId} style={styles.chartContainer}>
                            <h3 style={styles.title}>{config.title}</h3>
                            <HighchartsReact highcharts={Highcharts} options={options} />

                            <table style={styles.table}>
                                <thead>
                                    <tr>
                                        <th style={{ ...styles.tableHeaderCell, textAlign: 'left', paddingLeft: 15 }}>{config.title}</th>
                                        <th style={styles.tableHeaderCell}>Qtde</th>
                                        <th style={styles.tableHeaderCell}>%</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {config.categories.map((category, index) => (
                                        <tr key={category} style={index % 2 === 1 ? styles.tableRowEven : undefined}>
                                            <td style={{ ...styles.tableCell, textAlign: 'left', paddingLeft: 15 }}>{category}</td>
                                            <td style={styles.tableCell}>{counts[index]}</td>
                                            <td style={styles.tableCell}>{seriesData[index]}%</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td style={{ ...styles.tableFooterCell, textAlign: 'left', paddingLeft: 15 }}>Total</td>
                                        <td style={styles.tableFooterCell}>{total}</td>
                                        <td style={styles.tableFooterCell}>100%</td>
                                    </tr>
                                </tfoot>
                            </table>

                            <hr className="info-card-hr hr-mapa" />
                        </div>
                    );
                })}
            </div>
        );
    }
}

const styles = {
    chartContainer: {
        marginBottom: '8px'
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '12px',
        color: '#333',
        marginTop: '10px',
        fontFamily: 'Arial, sans-serif'
    },
    tableHeaderCell: {
        backgroundColor: '#4d5a31',
        color: '#fff',
        padding: '8px',
        textAlign: 'center',
        fontWeight: 'bold',
        textTransform: 'uppercase'
    },
    tableCell: {
        padding: '8px',
        borderBottom: '1px solid #eee',
        textAlign: 'center'
    },
    tableRowEven: {
        backgroundColor: '#f9f9f9'
    },
    tableFooterCell: {
        fontWeight: 'bold',
        padding: '10px',
        borderTop: '2px solid #4d5a31',
        textAlign: 'center'
    },
    title: {
        textAlign: 'center',
        color: '#5b595b',
        fontWeight: 'bold',
        fontSize: '21.9px',
        fontFamily: '"Archivo Expanded", Arial, sans-serif',
        marginBottom: '10px',
        textTransform: 'uppercase',
        paddingBottom: '10px'
    }
};

export default Graficos;
